import { DownloadOutlined, UserDeleteOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { FC, useState } from "react";
import * as XLSX from "xlsx";
import moment from "moment";
import { useAppSelector } from "store";
import { getExportAgentList } from "../../../services/agentsApi";
import { useNavigate } from "react-router-dom";

interface AgentExportToExcelProps {
  startDate: Date | undefined;
  endDate: Date | undefined;
}

const AgentExportToExcel: FC<AgentExportToExcelProps> = ({ startDate, endDate }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const { contact } = useAppSelector((state) => state.auth);

  const fecthData = async () => {
    try {
      const response = await getExportAgentList(
          {
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD"),
          }
        );
      if (response.status === "success" && response) {
        return response.contacts;
      }
    } catch (error) {
      console.log(error);

      return undefined;
    } finally {
      // setLoading(false)
    }
  };

  const RequestDeleteAction = async () => {
    navigate("/manage-agent/requestDelete");
  }

  const AgentExportToExcel = async () => {
    // console.log('AgentExportToExcel')

    setLoading(true);

    try {
      let data = await fecthData();

      let arr = data?.map((item, index) => {
        const newData = {
          ลำดับ: index + 1,
          "รหัสพนักงาน": item.agent_code,
          "ชื่อ - นามสกุล": item.agent_name,
          "เบอร์โทร": item.telephone,
          "แผนก": item.department_name,
          "จำนวนที่ขาย": item.count_sale,
          "มูลค่าขายรวม": item.total_sale_price,
          "ค่าคอมมิชชั่น": item.sale_commission,
        };

        return newData;
      });

      //  console.log(arr)

      if (arr) {
        let Heading = [
          [
            "ลำดับ",
            "รหัสพนักงาน",
            "ชื่อ - นามสกุล",
            "เบอร์โทร",
            "แผนก",
            "จำนวนที่ขาย",
            'มูลค่าขายรวม',
            "ค่าคอมมิชชั่น",
          ],
        ];

        // Had to create a new workbook and then add the header
        const wb = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
        XLSX.utils.sheet_add_aoa(ws, Heading);

        //Starting in the second row to avoid overriding and skipping headers
        XLSX.utils.sheet_add_json(ws, arr, { origin: "A2", skipHeader: true });

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, genfileName());
      } else {
        message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
      setLoading(false);
      return;
    }

    setLoading(false);
  };

  const genfileName = () => {
    const date = new Date();
    const fileName = `export_to_commistion_${moment(startDate).format(
      "DD-MM-YYYY"
    )}_${moment(endDate).format("DD-MM-YYYY")}.xlsx`;
    return fileName;
  };

  return (
    <>
    <Button
      type="default"
      style={{ marginRight: 10 }}
      icon={<DownloadOutlined />}
      size="middle"
      loading={loading}
      onClick={AgentExportToExcel}
    >
      Export Excel
    </Button>
    {/* <Button
      danger
      style={{ marginRight: 10 }}
      icon={<UserDeleteOutlined />}
      size="middle"
      // loading={loading}
      onClick={RequestDeleteAction}
    >
      รายการผู้ใช้ที่ร้องขอการลบ
    </Button> */}
    </>
  );
};

export default AgentExportToExcel;
